import * as React from 'react';
import * as classNames from 'classnames';

interface FailureWithMessageProps {
    message?: string;
}

export default class FailureWithMessage extends React.Component<FailureWithMessageProps> {
    constructor(props: FailureWithMessageProps) {
        super(props);
    }

    render() {      

        if (this.props.message) {
            const classes = classNames('fa', 'fa-exclamation-triangle', 'text-danger', "fa-4x");
            return (
                <div>
                    <p style={{ 'fontSize': 3 + 'rem' }} className="text-center">
                        <i className={classes} aria-hidden="true"></i>
                    </p>
                    <p className="text-center">{this.props.message}</p>
                </div>
            );
        } else {
            return null;
        }
    }
}
